import{lazy}from'react'
import{default as SEO}from'./seo/SEO'
const Map=lazy(()=>import('./map/Map'))
const Hero=lazy(()=>import('./hero/Hero'))
import{default as Loader}from'./loader/Loader'
const Navbar=lazy(()=>import('./navbar/Navbar'))
const OurPartners=lazy(()=>import('./ourPartners/OurPartners'))
const AsyncSelect=lazy(()=>import('./asyncSelect/AsyncSelect'))
const CompanyNews=lazy(()=>import('./companyNews/CompanyNews'))
const ContactForm=lazy(()=>import('./contactForm/ContactForm'))
const IImageViewer=lazy(()=>import('./photoViewer/PhotoViewer'))
const PopupADSModal=lazy(()=>import('./popupADSModal/PopupADSModal'))
const PasswordInput=lazy(()=>import('./passwordInput/PasswordInput'))
const CatalogSearch=lazy(()=>import('./catalogSearch/CatalogSearch'))
const SocialLinkFixed=lazy(()=>import('./socialLinkFixed/SocialLinkFixed'))
const BarcodeScannerComponent=lazy(()=>import('./barcodeScanner/BarcodeScanner'))
import{default as SectionVisibilityDetector}from'./sectionVisibilityDetector/SectionVisibilityDetector'
export{SEO,Map,Hero,Loader,Navbar,AsyncSelect,CompanyNews,ContactForm,PasswordInput,CatalogSearch,PopupADSModal,IImageViewer,SectionVisibilityDetector,SocialLinkFixed,BarcodeScannerComponent,OurPartners}